module.exports = __webpack_public_path__ + "bronze_badge.png";